import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSyncAlt, faKey, faUnlock } from '@fortawesome/free-solid-svg-icons';
import encryptionStats from '../../data/encryptionStats.json';

// Map icon strings to FontAwesome icons
const iconMapping = {
  lock: faLock,
  refresh: faSyncAlt,
  key: faKey,
  unlock: faUnlock,
};

const StatCards = () => {
  // Add icons to the card data
  const cardData = encryptionStats.map(card => ({
    ...card,
    icon: (
      <FontAwesomeIcon
        icon={iconMapping[card.icon]}
        className={`text-3xl ${card.textColor}`}
      />
    ),
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-5">
      {cardData.map((card, idx) => (
        <div
          key={idx}
          className={`flex items-center justify-between bg-white shadow-md p-5 rounded-lg border-l-4 ${card.borderColor} hover:shadow-lg transition-all duration-300`}
        >
          <div className="flex flex-col gap-2">
            <h3 className="text-gray-500 text-sm">{card.title}</h3>
            <p className="text-2xl font-bold text-gray-900">{card.value}</p>
            <p className={`text-sm ${card.textColor}`}>{card.percentage}</p>
          </div>
          <div className={`w-14 h-14 flex items-center justify-center rounded-full ${card.iconBg}`}>
            {card.icon}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;